module.exports = __webpack_public_path__ + "img/1.93a3af8a.jpg";